import fetchGameHtml from 'utils/fetchGameHtml';
import { resolveLotteryGameSource } from 'config/aiWebGameSource';
import { isAllowedCdnUrl } from 'client/components/AIWebGame/utils/securityConfig';

/**
 * 開機時 prefetch AI web game 的遊戲 HTML（#86eyjp7qb）。
 *
 * 為什麼要有這支：遊戲 HTML 其實只需要一個 CDN URL 就能開始下載，卻因為 GameIframe 掛載得晚
 * 實際上排在整條資料鏈的最後面（infos → auth → entries → entries/latest → prizes → 才輪到它）
 * 扭蛋機在 Fast 3G + 4x CPU 下實測要到 13.1s 才開始抓，玩家在那之前看到的是一片空舞台。infos 一回來（實測 1.3s）就有 lotteries，也就有 URL，沒有理由再等後面那四支 API。
 *
 * 只是「先打」，不改變任何載入邏輯：fetchGameHtml 以 url 為 key 快取 promise，
 * GameIframe 之後照原樣呼叫，命中的是同一份（不會變成兩次請求）；失敗不入快取，
 * GameIframe 那次會自己重打並照原本的錯誤路徑處理，所以這裡的失敗一律吞掉、不上報。
 *
 * @param {object} promoInfoPayload - infos API 的原始回應（未經 mappingPromoInfoApi2State）
 */
export default function prefetchLotteryGameHtml(promoInfoPayload) {
    try {
        const lotteries = promoInfoPayload?.lotteries;
        if (!Array.isArray(lotteries)) return;

        const gameCdnUrls = new Set();
        lotteries.forEach(({ lottery, lotterySetting } = {}) => {
            const { gameCdnUrl } = resolveLotteryGameSource(
                {
                    type: lottery?.type,
                    uuid: lottery?.uuid,
                    AnimationSettings: lotterySetting?.AnimationSettings
                },
                { warnOnMissing: false }
            );
            if (gameCdnUrl && isAllowedCdnUrl(gameCdnUrl)) gameCdnUrls.add(gameCdnUrl);
        });

        gameCdnUrls.forEach(url => {
            // prefetch 失敗不做任何事，真正的錯誤處理歸 GameIframe，這裡若不接住會變成 unhandled rejection
            fetchGameHtml(url).catch(() => {});
        });
    } catch (err) {
        // prefetch 屬加分項，payload format 有出入時安靜略過，絕不影響 init 流程
        console.warn('[prefetchLotteryGameHtml] 預熱略過:', err?.message);
    }
}
